<template>
  <v-dialog scrollable v-model="settingsDialogActive" persistent width="500">
    <v-card>
      <v-card-title class="headline" primary-title>
        <v-icon class="pr-2">mdi-settings</v-icon>Innstillinger
      </v-card-title>
      <v-card-text>
        <p>
          Her kan du endre innstillingene til {{ appTitle }}. Valgene du gjør
          her lagres i nettleseren din og huskes til neste gang du bruker
          løsningen. De fleste innstillingene trer i kraft umiddelbart, bortsett
          fra innstillinger knyttet til tegning, som trer i kraft neste gang
          tegnemodus aktiveres.
        </p>
        <div
          v-for="settingCategory in settingsMetadata"
          :key="settingCategory.name"
        >
          <v-subheader class="pl-1 pb-0">{{
            settingCategory.title
          }}</v-subheader>
          <template v-for="setting in settingCategory.settings">
            <v-select
              :key="setting.id"
              v-if="setting.type === 'select'"
              :items="setting.options"
              :value="userSettings[setting.id]"
              :return-object="true"
              item-text="name"
              @change="updateSetting(setting.id, $event)"
              box
              :label="setting.name"
              dense
              flat
            ></v-select>
            <v-checkbox
              v-if="setting.type === 'checkbox'"
              :key="setting.id"
              :value="userSettings[setting.id]"
              color="primary"
              @change="updateSetting(setting.id, $event)"
              :label="setting.name"
            ></v-checkbox>
          </template>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn flat @click="resetUserSettings">
          Tilbakestill innstillinger
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn flat @click="close">
          Ferdig
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  computed: {
    ...mapState(["appTitle", "settingsMetadata", "userSettings"]),
    settingsDialogActive: {
      set(settingsDialogActive) {
        this.$store.dispatch("setSettingsDialogActive", settingsDialogActive);
      },
      get() {
        return this.$store.state.settingsDialogActive;
      }
    }
  },
  data() {
    return {
      selectedTheme: null
    };
  },
  methods: {
    ...mapActions(["setUserSetting", "resetUserSettings"]),
    close() {
      this.settingsDialogActive = false;
    },
    updateSetting(id, evt) {
      let value =
        evt === null ? false : evt.hasOwnProperty("value") ? evt.value : evt;
      this.setUserSetting({
        id: id,
        value: value
      });
    }
  }
};
</script>

<style></style>
